'use strict';

var ServiceAnalysisModeDirective = function ServiceAnalysisModeDirective(transitionDataService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/service-analysis-mode.html'),
    controller: 'ServiceAnalysisModeController',
    scope: {
      filterData: '=',
      scenarioName: '=?',
      screenState: '=',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      var serviceGridId = 'service-demand-analysis';
      scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
        scope.setServiceViewReady(mode === 'service');

        // when switching between tabs: reset the old data - the handler 'grid:afterUpdateBoundData' will be called indirectly
        if (transitionDataService.has(serviceGridId)) {
          scope.$broadcast('grid:undo', serviceGridId);
        }
      });
      scope.$on('grid:afterUpdateBoundData', function (event, gridData, gridId) {
        // when the grid data is loaded for the first time or reloaded
        if (gridId === serviceGridId && transitionDataService.has(serviceGridId)) {
          scope.$broadcast('grid:fillBulkOverrides', serviceGridId, transitionDataService.pop(serviceGridId));
        }
      });
      scope.setSearchRule();
    }
  };
};
ServiceAnalysisModeDirective.$inject = ['TransitionDataService'];
module.exports = ServiceAnalysisModeDirective;